// Example health metrics for demo mode
import { Heart, Activity, Thermometer } from 'lucide-react';

export const exampleHealthMetrics = [
  {
    name: 'Blood Pressure',
    value: '120/80',
    unit: 'mmHg',
    trend: 'stable',
    icon: Heart,
    color: 'text-green-500',
  },
  {
    name: 'Heart Rate',
    value: '72',
    unit: 'bpm',
    trend: 'normal',
    icon: Activity,
    color: 'text-blue-500',
  },
  {
    name: 'Temperature',
    value: '98.6',
    unit: '°F',
    trend: 'normal',
    icon: Thermometer,
    color: 'text-orange-500',
  },
]; 